import { render, staticRenderFns } from "./MechReview.vue?vue&type=template&id=0ca85656"
import script from "./MechReview.vue?vue&type=script&lang=js"
export * from "./MechReview.vue?vue&type=script&lang=js"
import style0 from "./MechReview.vue?vue&type=style&index=0&id=0ca85656&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports